import Component from '@glimmer/component';

import { t } from 'ember-intl';

import { getBem } from 'umg-ember-backend/utils/get-bem';

import ActivityFeedItem from './item';
import styles from './styles.module.css';

const bem = getBem(styles);

interface Activity {
  type: string;
  id: string;
  editedAt: string;
}

interface DashboardActivityFeedSignature {
  Args: {
    activities: Activity[];
  };
}

export default class DashboardActivityFeedComponent extends Component<DashboardActivityFeedSignature> {
  get activities() {
    return this.args.activities ?? [];
  }

  <template>
    <section class={{(bem)}} data-test-activity-feed>
      <h2>{{t 'dashboard.activity_feed'}}</h2>
      <ol class={{bem 'list'}}>
        {{#each this.activities key='@index' as |activity|}}
          <li class={{bem 'item'}} data-test-activity-item>
            <ActivityFeedItem @activity={{activity}} />
          </li>
        {{else}}
          <li>{{t 'dashboard.no_activity'}}</li>
        {{/each}}
      </ol>
    </section>
  </template>
}
